import { PackagedState } from "../state/reducers/packagedReducer";
import { Entity, ID, Part } from "../types";

export type GetPackagePartFn = (
  parts: Entity<Part>,
  packaged: PackagedState
) => (id: ID) => Part | undefined;

const getPackagePart: GetPackagePartFn = (parts, packaged) => (id) => {
  const packageData = packaged.byId[id];
  if (!packageData) return;
  const packageId = packageData.fromId;
  return parts.byId[packageId];
};

export default getPackagePart;
